import * as yup from 'yup';
export const entryChannelSchema = yup.string().nullable().required('required');
